"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DepositStatus_1 = __importDefault(require("./DepositStatus"));
exports.default = DepositStatus_1.default;
